export default "__VITE_ASSET__YUUkKeCo__"